import { GROUPED_ID_SEPARATOR } from '../constants';
export const getGroupItemId = (index, parentId) => parentId ? `${parentId}${GROUPED_ID_SEPARATOR}${index}` : `${index}`;
export const parseGroupItemId = (id) => id.split(GROUPED_ID_SEPARATOR);
